var Bluebird = require('bluebird/js/browser/bluebird.core');
Bluebird.config({
  cancellation: true,
  longStackTraces: false,
  warnings: false
});
module.exports = Bluebird;



//////////////////
// WEBPACK FOOTER
// ./~/keen-analysis/lib/utils/promise.js
// module id = 1824
// module chunks = 0